import AbstractComponent from "./abstract-component";

const createTemplate = (className, goodsName, title) => {
  return (
    `<section class="${className}__goods goods">
      <div class="goods__wrap container">
        <h2 class="goods__title">${title}</h2>

        <div class="main-page__content swiper swiper--${goodsName}">
          <ul class="main-page__list swiper-wrapper"></ul>

          <button class="main-page__swiperButton main-page__swiperButton--prev swiper__button swiper__button--prev" type="button" title="Предыдущий">
            Предыдущий
            <svg className="" width="10" height="10" aria-hidden="true">
              <use href="sienge/img/sprite.svg#arrow-small-left"></use>
            </svg>
          </button>

          <button class="main-page__swiperButton main-page__swiperButton--next swiper__button swiper__button--next" type="button" title="Следующий">
            Следующий
            <svg className="" width="10" height="10" aria-hidden="true">
              <use href="sienge/img/sprite.svg#arrow-small-right"></use>
            </svg>
          </button>
        </div>
      </div>
    </section>`
  );
};

export default class GoodsComponent extends AbstractComponent {
  constructor({className, goodsName, title = ``}) {
    super();

    this._className = className;
    this._goodsName = goodsName;
    this._title = title;
  }

  getTemplate() {
    return createTemplate(this._className, this._goodsName, this._title);
  }
}
